<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='工单转派'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='450'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="form.personId">
                  <v-radio
                    v-for="(item, idx) in items"
                    :key="idx"
                    :label="item.name"
                    :value="item.value"
                    :rules="required"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { getByPid } from '@/api/system/dictionary.js'
  import { save } from '@/api/order/index.js'

  export default {
    name: 'OrderAssign',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => (!!value && value.length > 0) || '此项为必填项!'
        ],
        items: [],
        form: {
          id: '',
          personId: ''
        }
      }
    },
    methods: {
      save () {
        this.form.orderStatus = 0
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      getByPid () {
        getByPid(this.$constants.orderUsersPid).then(res => {
          if (res.status === 200) {
            this.items = res.data
          }
        })
      },
      dialogChange (val) {
        this.reset()
        this.item.show = val
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        }
      },
      reset () {
        if (!isEmpty(this.$refs.form)) {
          this.$refs.form.reset()
        }
      }
    },
    created() {
      this.getByPid()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
